import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/billing-invoices'
import Menu from '/components/billing/nav-menu'
import InvoicesTable from '/components/billing/invoices-table'

const BillingInvoices = () => {

  const navigate = useNavigate()
  const { user } = useContext(AppContext)
  
  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing Invoices" HelpText={HelpText}heading="Invoices"  menu={<Menu />}>
      <div className='flex flex-col'>
        <InvoicesTable />
      </div>
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingInvoices

